import { ResponsiveContainer, BarChart, CartesianGrid, XAxis, YAxis, Tooltip, Legend, Bar } from 'recharts';

interface NetProfitComparisonChartProps {
  currentPeriod: {
    revenues: number;
    expenses: number;
    netProfit: number;
  };
  previousPeriod: {
    revenues: number;
    expenses: number;
    netProfit: number;
  };
  formatCurrency: (amount: number) => string;
}

export const NetProfitComparisonChart = ({ 
  currentPeriod, 
  previousPeriod,
  formatCurrency 
}: NetProfitComparisonChartProps) => {
  const data = [
    {
      period: 'Période précédente',
      revenus: previousPeriod.revenues,
      dépenses: -previousPeriod.expenses,
      bénéfice: previousPeriod.netProfit
    },
    {
      period: 'Période en cours',
      revenus: currentPeriod.revenues,
      dépenses: -currentPeriod.expenses,
      bénéfice: currentPeriod.netProfit
    }
  ];

  return (
    <ResponsiveContainer width="100%" height="100%">
      <BarChart data={data}>
        <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" />
        <XAxis 
          dataKey="period" 
          stroke="#64748b"
          tick={{ fill: '#64748b', fontSize: 12 }}
          tickLine={{ stroke: '#94a3b8' }}
        />
        <YAxis 
          stroke="#64748b"
          tick={{ fill: '#64748b', fontSize: 12 }}
          tickLine={{ stroke: '#94a3b8' }}
          tickFormatter={(value) => formatCurrency(value)}
        />
        <Tooltip 
          formatter={(value: number) => formatCurrency(value)}
          contentStyle={{ 
            backgroundColor: '#fff',
            border: '1px solid #e2e8f0',
            borderRadius: '0.5rem',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
          }}
          cursor={{ fill: 'rgba(0,0,0,0.05)' }}
        />
        <Legend 
          wrapperStyle={{
            paddingTop: '1rem'
          }}
        />
        <Bar 
          dataKey="revenus" 
          fill="#3b82f6" 
          name="Revenus"
          radius={[4, 4, 0, 0]}
        />
        <Bar 
          dataKey="dépenses" 
          fill="#f97316" 
          name="Dépenses"
          radius={[4, 4, 0, 0]}
        />
        <Bar 
          dataKey="bénéfice" 
          fill="#22c55e" 
          name="Bénéfice Net"
          radius={[4, 4, 0, 0]}
        />
      </BarChart>
    </ResponsiveContainer>
  );
};